import { first, map, switchMap } from "rxjs/operators";
import lodashMap from "lodash-es/map";
import { ApiService } from "@app/core/api.service";
import { Injectable } from "@angular/core";
import { ServiceArea } from "@app/shared/service-area";
import { BehaviorSubject, Observable, Subject } from "rxjs";
import { User } from "@app/shared/user";
import { UserService } from "@app/core/user.service";

export interface ServiceAreaPediatricsResponse {
  pediatrics_available: boolean;
}

const publicServiceAreaPath = "/api/v2/public/service_areas";

@Injectable()
export class ServiceAreaService {
  private _serviceAreas$ = new Subject<Array<ServiceArea>>();
  readonly serviceAreas$ = this._serviceAreas$.asObservable();

  private _pediatricsAvailableInServiceArea$ = new Subject<boolean>();
  readonly pediatricsAvailableInServiceArea$ = this._pediatricsAvailableInServiceArea$.asObservable();

  constructor(private apiService: ApiService, private userService: UserService) {}

  getServiceAreas() {
    this.apiService
      .get(publicServiceAreaPath)
      .pipe(
        map(result => lodashMap(result, sa => new ServiceArea(sa))),
        map(allServiceAreas =>
          allServiceAreas.filter(serviceArea => !serviceArea.registration_hidden)
        )
      )
      .subscribe(serviceAreas => this._serviceAreas$.next(serviceAreas));

    return this.serviceAreas$;
  }

  getPediatricsAvailability(): void {
    this.userService.user$
      .pipe(
        first(),
        switchMap((user: User) => {
          const pedsAvailablePath = `${publicServiceAreaPath}/${
            user.serviceArea.id
          }/pediatrics_available`;
          return this.apiService.get(pedsAvailablePath);
        })
      )
      .subscribe((response: ServiceAreaPediatricsResponse) => {
        this._pediatricsAvailableInServiceArea$.next(response.pediatrics_available);
      });

    this.userService.getUser();
  }
}
